<template>
  <section class="viewsrhqy_UserManage p-4">
    <div class="search-container flex items-start justify-between">
      <div class="inline-flex items-start">
        <el-button v-has="['c-contact-contact-add']" @click="onAdd" size="medium" type="primary">添加用户</el-button>
        <el-button v-has="['c-contact-contact-import']" @click="showImport = true" size="medium">导入</el-button>
        <el-button v-has="['c-contact-contact-batchDelete']" type="danger" @click="() => onDelete()"
          size="medium">删除</el-button>
        <el-button v-has="['c-contact-contact-batchEnable']" type="success" @click="onBatchSwitchState(1)"
          size="medium">启用</el-button>
        <el-button v-has="['c-contact-contact-batchDisable']" type="warning" @click="() => onBatchSwitchState(2)"
          size="medium">禁用</el-button>
        <el-button v-has="['c-contact-contact-export']" @click="onExport" size="medium">导出</el-button>
        <el-form ref="form" label-width="4em">
          <el-form-item label="角色">
            <el-select v-model="queryParam.role_id" placeholder="请选择角色">
              <el-option v-for="item in baseRole" :key="item.value" :value="item.id" :label="item.name"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <el-input class="w-80" v-model="queryParam.keyword" clearable placeholder="搜索账号、手机号和联系人"></el-input>
    </div>
    <template v-if="firstRoleId">
      <c-table isSelection :selection.sync="rowKeySelection" :selectRows.sync="rowSelection" id="baseManage"
        :isIndex="false" :data="dataSource" :columns="columns" :query.sync="pagintion" :total="total"
        @loadPage="loadData">
        <template slot="ref_supplier_list" slot-scope="scope">
          <p v-for="item in scope.row.ref_supplier_list" :key="item.id">
            {{ item.full_name }}（{{ item.supplier_nature_name}}）
          </p>
        </template>
        <template slot="action" slot-scope="scope">
          <el-row type="flex" justify="space-around" align="middle">
            <c-link v-has="['c-contact-contact-detail']" @click="onView(scope.row)" label="查看"></c-link>
            <c-link v-has="['c-contact-contact-update']" @click="onEdit(scope.row)" label="修改"></c-link>
            <el-dropdown @command="command => onChangeCommand(command, scope.row)"
              v-has="['c-contact-contact-switch', 'c-contact-contact-delete', 'c-contact-contact-update', 'c-contact-contact-update', 'c-contact-contact-unbind']">
              <c-link>
                更多<i class="el-icon-arrow-down el-icon--right"></i>
              </c-link>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-has="['c-contact-contact-switch']" command="start"
                  v-if="scope.row.state != 1">启用</el-dropdown-item>
                <el-dropdown-item v-has="['c-contact-contact-switch']" command="stop"
                  v-if="scope.row.state != 2">禁用</el-dropdown-item>
                <el-dropdown-item v-has="['c-contact-contact-delete']" command="del">删除</el-dropdown-item>
                <el-dropdown-item v-has="['c-contact-contact-update']" command="rePassword">重置密码</el-dropdown-item>
                <el-dropdown-item
                  v-if="currenRoleCode === 'chip'"
                  v-has="['c-contact-contact-update']"
                  command="reQueryPassword"
                >
                  重置查询密码
                </el-dropdown-item>
                <el-dropdown-item command="ReBindDevice" v-has="['c-contact-contact-unbind']"
                  v-if="scope.row.device_id">重新绑定设备</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </el-row>
        </template>
      </c-table>
    </template>
    <c-import v-bind="importOptions" :show.sync="showImport" @finish="refreshData">
      <span slot="desc">
        <span>
          3、仅支持模板信息格式，请勿填写其他数据内容
        </span>
        <template v-if="roleCode === 'gfsupplier'">
          <br />
          <span>
            4、关联子供应商必填，请按“供应商编码,供应商名称”填写，多组请用分号分隔，例如：90069,黄晃林；1000000360,韦雨良
          </span>
        </template>
        <br />
      </span>
    </c-import>
  </section>
</template>

<script>
import initListMinxin from "@/mixins/jl/initListMinxin";
import mixinTableLyout from "@/views/rhqy/config/mixinTableLyout.js";
import { mapGetters, mapActions } from "vuex";
export default {
  data() {
    return {
      showImport: false,
      roles: [],
      queryParam: {
        role_id: "",
        keyword: "",
        state: ""
      },
      columns: [
        {
          label: "所属基地",
          prop: "baseName",
          formatData: () => this.baseInfo.com_name
        },
        {
          label: "角色",
          prop: "roleName",
          formatData: row => {
            if (this.roleMap[row.role_id]) {
              return this.roleMap[row.role_id].name;
            }
            return "--";
          }
        },
        { label: "账号", prop: "account" },
        {
          label: "客户编号",
          prop: "customer_unit_code",
          show: () => this.currenRoleCode === "customer",
          formatData: row => row.unit_code
        },
        {
          label: "供应商的客户编号",
          prop: "supplier_customer_unit_code",
          show: () => this.currenRoleCode === "supplier_customer",
          formatData: row => row.unit_code
        },
        {
          label: "木片厂名",
          prop: "full_name",
          show: () => this.currenRoleCode === "chip"
        },
        {
          label: "供应商名称",
          prop: "ref_supplier_list",
          show: () => this.currenRoleCode === "chip"
        },
        {
          label: "供应商编号",
          prop: "supplier_unit_code",
          show: () => ["supplier", "gfsupplier"].includes(this.currenRoleCode),
          formatData: row => row.unit_code
        },
        {
          label: "供应商名称",
          prop: "full_name",
          show: () => ["supplier", "gfsupplier"].includes(this.currenRoleCode)
        },
        { label: "联系人", prop: "contact" },
        { label: "手机号", prop: "phone" },
        {
          label: "状态",
          prop: "state",
          width: 80,
          formatData(row) {
            const map = { 0: "禁用", 1: "启用", 2: "禁用", 3: "冻结" };
            return map[row.state] || "";
          }
        },
        {
          label: "车牌号",
          prop: "license_plate",
          show: () => this.currenRoleCode === "driver"
        },
        {
          label: "绑定状态",
          prop: "device_id",
          width: 100,
          show: () => this.currenRoleCode === "driver",
          formatData(row) {
            return !row.device_id ? "未绑定" : "已绑定";
          }
        },
        { label: "操作", prop: "action", width: 160 }
      ],
      exportDataEvent: params => {
        return this.$common.http({
          url: "/api/queue/admin/export_user",
          data: params,
          noLoading: true
        })
      },
      disabledCreated: true
    };
  },
  computed: {
    ...mapGetters(["baseRole", "firstRoleId", "baseInfo"]),
    importOptions() {
      return {
        downloadDemoName: `${this.roleName}导入模板`,
        templateUrl: `/api/queue/admin/download_template?file_name=import_${this.roleTag}.xlsx`,
        importUrl: "/api/queue/admin/import_user",
        otherParams: {
          role_id: this.queryParam.role_id
        }
      }
    },
    roleMap() {
      let map = {};
      Object.values(this.baseRole).map(item => {
        map[item.id] = item;
      });
      return map;
    },
    currenRoleCode() {
      const { role_id } = this.queryParam;
      if (role_id && this.roleMap[role_id]) {
        return this.roleMap[role_id].code;
      }
      return "";
    },
    roleCode() {
      const { role_id } = this.queryParam;
      if (role_id && this.roleMap[role_id]) {
        const role = this.roleMap[role_id];
        return role.code;
      }
      return "";
    },
    roleName() {
      const { role_id } = this.queryParam;
      if (role_id && this.roleMap[role_id]) {
        const role = this.roleMap[role_id];
        return role.name;
      }
      return "";
    },
    roleTag() {
      switch (this.roleCode) {
        case "supplier":
          return "supply";
        case "gfsupplier":
          return "guofei_supply";
        case "chip":
          return "ship";
        case "customer":
          return "client";
        case "supplier_customer":
          return "supply_client";
        case "driver":
          return "driver";
        case "gate_guard":
          return "gate_guard";
        default:
          return "user";
      }
    }
  },
  mixins: [initListMinxin, mixinTableLyout],
  async created() {
    // 确保roleMap已加载
    await this.loadRoleMap();
    // 如果roleMap有数据，设置第一个roleId
    if (!this.isValidRoleId(this.queryParam.role_id) && this.firstRoleId) {
      this.queryParam.role_id = this.firstRoleId;
    }
  },
  activated() {
    this.loadData();
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (from.name === "rhqyOrgUserDetail") {
        const { role_id } = from.query;
        // 仅回填有效角色，避免把详情页 URL 中的脏参数带回列表页。
        if (vm.isValidRoleId(role_id)) {
          vm.queryParam.role_id = role_id;
        }
      }
    });
  },
  methods: {
    ...mapActions(["getBaseRole"]),
    // 校验当前角色 ID 是否有效，避免使用 undefined/null 或不存在的角色值。
    isValidRoleId(roleId) {
      return !!roleId && roleId !== "undefined" && roleId !== "null" && !!this.roleMap[roleId];
    },
    // 统一生成带角色的跳转参数，保证新增、查看、编辑都带上可用的 role_id。
    buildRoleQuery() {
      const roleId = this.isValidRoleId(this.queryParam.role_id) ? this.queryParam.role_id : this.firstRoleId;
      return this.isValidRoleId(roleId) ? {role_id: roleId} : {};
    },
    async loadRoleMap() {
      try {
        // 如果roleMap为空，则获取数据
        if (!this.firstRoleId) {
          await this.getBaseRole();
        }
      } catch (error) {
        console.error("加载角色列表失败:", error);
      }
    },
    // 查看时透传当前有效角色，确保详情页按正确角色类型加载数据。
    onView(row) {
      this.$router.push({
        path: `/rhqy/org/userDetail/${row.id}/2`,
        query: this.buildRoleQuery()
      });
    },
    // 新增时透传当前有效角色，避免详情页初始化为无效角色。
    onAdd() {
      this.$router.push({
        path: `/rhqy/org/userDetail/${0}/1`,
        query: this.buildRoleQuery()
      });
    },
    // 编辑时透传当前有效角色，确保表单按正确角色上下文展示。
    onEdit(row) {
      this.$router.push({
        path: `/rhqy/org/userDetail/${row.id}/1`,
        query: this.buildRoleQuery()
      });
    },
    onChangeCommand(command, row) {
      if (command == "start") {
        this.onChangeState(1, row.id);
      }
      if (command == "stop") {
        this.onChangeState(0, row.id);
      }
      if (command == "del") {
        this.onDelete(row.id);
      }
      if (command == "ReBindDevice") {
        this.onReBindDevice(row.id);
      }
      if (command == "rePassword") {
        this.onResetPassword(row);
      }
      if (command == "reQueryPassword") {
        this.onResetQueryPassword(row);
      }
    },
    onResetPassword(row) {
      this.$confirm(`确认重置密码吗？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(async () => {
        console.log(this.roleTag, row.id)
        try {
          await this.$common.http({
            url: "/api/contact/reset_password",
            data: {
              id: ['driver', 'gate_guard', 'user'].includes(this.roleTag) ? row.id : row.user_id
            }
          });
          this.$message.success("重置密码成功");
          this.refreshData();
        } catch (error) { }
      });
    },
    // 木片厂查询密码与登录密码分离，后台这里只重置查询服务使用的独立密码。
    onResetQueryPassword(row) {
      this.$confirm(`确认重置查询密码吗？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(async () => {
        try {
          await this.$common.http({
            url: "/api/queue/admin/reset_user_query_password",
            data: {
              user_id: row.user_id
            }
          });
          this.$message.success("重置查询密码成功");
          this.refreshData();
        } catch (error) {}
      });
    },
    onChangeState(command, id) {
      const tag = command == 1 ? "启用" : "禁用";
      this.$confirm(`确定${tag}选中的用户吗？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let url = "";
        let params = {};
        if (
          ["supplier", "gfsupplier", "chip", "customer", "supplier_customer"].includes(
            this.roleCode
          )
        ) {
          url = "/api/queue/admin/enable_unit";
        } else {
          url = "/api/contact/switch_user";
          params.enable = command == 1 ? 1 : 0;
        }
        this.$common
          .http({
            url,
            data: {
              id,
              ...params
            }
          })
          .then(() => {
            this.$message.success(`${tag}成功`);
            this.refreshData();
          });
      });
    },
    async loadData() {
      const data = Object.assign(this.queryParam, this.pagintion);
      if (this.roleCode) {
        if (
          ["supplier", "gfsupplier", "chip", "customer", "supplier_customer"].includes(
            this.roleCode
          )
        ) {
          const dataObj = await this.$common.http({
            url: "/api/queue/admin/query_unit",
            data
          });
          this.total = dataObj.data.data.total;
          this.dataSource = dataObj.data.data.data;
        } else {
          const dataObj = await this.$common.http({
            url: "/api/contact/search",
            data: {
              ...data,
              limit: data.page_size,
              offset: (data.page - 1) * data.page_size,
              type: 2
            }
          });
          this.total = dataObj.data.data.total;
          this.dataSource = dataObj.data.data.items;
        }
      }
    },
    onReBindDevice(id) {
      this.$confirm(`确定重新绑定设备吗？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$common
          .http({
            url: "/api/contact/unbind_device",
            data: { id }
          })
          .then(() => {
            this.$message.success(`解除绑定设备成功`);
            this.refreshData();
          });
      });
    },
    onDelete(rowId) {
      let selection = [];
      if (rowId) {
        selection = [rowId];
      } else {
        if (this.rowKeySelection.length === 0) {
          this.$message.warning("请选择要删除的用户");
          return;
        }
        selection = this.rowKeySelection;
      }
      const text =
        this.rowKeySelection.length > 0
          ? "选中" + this.rowKeySelection.length + "个记录，"
          : "";
      this.$confirm(text + "确认删除用户，删除后数据将无法恢复！", "删除", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let url = "";
        if (
          ["supplier", "gfsupplier", "chip", "customer", "supplier_customer"].includes(
            this.roleCode
          )
        ) {
          url = "/api/queue/admin/del_unit";
        } else {
          url = "/api/contact/delete_user";
        }
        const postEvent = selection.map(id => {
          return this.$common.http({
            url,
            data: { id }
          });
        });
        Promise.all(postEvent).then(() => {
          this.$message.success("删除成功");
          this.refreshData();
        });
      });
    },
    onBatchSwitchState(state) {
      const tag = state === 1 ? '启用' : '禁用'
      if (this.rowKeySelection.length === 0) {
        this.$message.warning(`请选择要${tag}的用户`);
        return;
      }
      console.log(this.rowSelection);
      const hasDifferent = this.rowSelection.find((e) => e.state === state);
      if (hasDifferent) {
        this.$message.warning(`已选用户存在已${tag}的数据！`);
        return;
      }
      this.$confirm(`确定${tag}选中的用户吗？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(async () => {
        try {
          let url = ""
          if (["supplier", "gfsupplier", "chip", "customer", "supplier_customer"].includes(this.roleCode)) {
            url = "/api/queue/admin/batch_enable_unit"
          } else {
            url = "/api/contact/batch_switch_user"
          }
          await this.$common.http({
            url,
            data: {
              ids: this.rowKeySelection,
              enable: state === 2 ? 0 : 1
            }
          });
          this.$message.success(`${tag}成功`);
          this.refreshData();
        } catch (error) {};
      })
    },
    onBatchStop() {

    },
  }
};
</script>
